module.exports = ".horizontal {\n    display: flex;\n}\n\nmat-card {\n    margin: 0pt 10pt 10pt 0pt;\n}\n"